import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import VueI18Next from '@/library/VueI18Next';
import Vue2TouchEvents from 'vue2-touch-events';
import fontAwesome from '@/library/fontAwesome';
import bootstrapVue from '@/library/bootstrapVue';

Vue.config.productionTip = false;

bootstrapVue.init();
fontAwesome.init();
Vue.use(Vue2TouchEvents);

new Vue({
    router,
    i18n: VueI18Next,
    render: (h) => h(App),
}).$mount('#app');
